import React from 'react';
import { Modal } from 'react-bootstrap';
import { actions } from 'react-redux-form';
import { connect, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { push } from 'connected-react-router';

const Comp = ({ show }) => {
  const dispatch = useDispatch();
  const close = () => {
    dispatch(actions.change('forms.standard.disabledShowModal', true));
    dispatch(actions.change('forms.setting.taskShowModal', false));
  };
  const goTask = () => {
    dispatch(actions.change('forms.setting.taskShowModal', false));
    dispatch(push('/task'));
  };
  return (
    <Modal show={show} className="information onboarding">
      <button
        type="button"
        className="btn-close"
        data-bs-dismiss="modal"
        onClick={close}
        aria-label="Close"
      ></button>
      <section>
        <header>
          <div>
            <img src="/images/info.svg" alt="!" />
            <h2>申告書作成前に必要な手続きや書類の準備はお済みですか？</h2>
          </div>
          <p>
            手続きが分からない、準備書類が不明で困っている方もご安心ください。
            相続税申告のタスクとスケジュールを簡単に把握できる、無料診断をご用意しています。
          </p>
        </header>
        <figure>
          <img
            src="/images/task-schedule-logo.png"
            alt="ひと目でわかる相続申告タスクとスケジュール"
          />
        </figure>
        <div className="button-column">
          <Link onClick={goTask} className="btn-ai btn btn-primary--outline">
            『無料診断』を受ける
            <img src="/images/chevron-right-primary.svg" alt="→" />
          </Link>
          <Link onClick={close} className="btn btn-primary btn-ai mb-4">
            【無料】すぐに申告書を作成する
            <img src="/images/chevron-right-white.svg" alt="→" />
          </Link>
        </div>
      </section>
    </Modal>
  );
};

export default connect((s) => s)(Comp);
